var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#132142;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-clock",
    "data-name": "Icon awesome-user-clock",
    className: "cls-1",
    d: "M831.87,486.94C700,486.91,593.07,593.78,593,725.65s106.84,238.8,238.7,238.83,238.8-106.84,238.84-238.7v-.07C1070.66,593.93,963.9,487,832.12,486.94ZM938,736.16a16.21,16.21,0,0,1-16.09,16.08H821.45a16.21,16.21,0,0,1-16.09-16.08v-127a16.21,16.21,0,0,1,16.09-16.08h20.84a16.21,16.21,0,0,1,16.09,16.08v90h63.5A16.2,16.2,0,0,1,938,715.26ZM540,725.73a290.83,290.83,0,0,1,30.23-128.5,220.82,220.82,0,0,0-40.79-4.17H501.71a288.65,288.65,0,0,1-241.75,0H232.28c-123.07,0-222.83,99.78-222.86,222.85v69A79.6,79.6,0,0,0,89,964.47H664.53A291.86,291.86,0,0,1,540,725.71ZM380.84,540c117.21,0,212.24-95,212.24-212.24s-95-212.24-212.24-212.24-212.24,95-212.24,212.24h0C168.59,445,263.6,540,380.81,540Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.10e0fea09fdd9c5a94b408cf787d89db.svg";
export { ForwardRef as ReactComponent };